var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePayLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GooglePayLogo_svg__Group_7",
    "data-name": "Group 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 55.34 21.713"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "GooglePayLogo_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "GooglePayLogo_svg__Rectangle_6",
    "data-name": "Rectangle 6",
    fill: "none",
    d: "M0 0h55.34v21.713H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".GooglePayLogo_svg__cls-3{fill:#3c4043}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GooglePayLogo_svg__Group_6",
    "data-name": "Group 6",
    clipPath: "url(#GooglePayLogo_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "GooglePayLogo_svg__Path_15",
    "data-name": "Path 15",
    className: "GooglePayLogo_svg__cls-3",
    d: "M226.932 20.307v6.4H224.9V10.9h5.386a4.857 4.857 0 013.481 1.365 4.389 4.389 0 011.46 3.333 4.37 4.37 0 01-1.46 3.354 4.849 4.849 0 01-3.481 1.344h-3.354zm0-7.46v5.513h3.4a2.712 2.712 0 002.01-.815 2.664 2.664 0 00.815-1.936 2.819 2.819 0 00-2.825-2.751h-3.4z",
    transform: "translate(-201.103 -9.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GooglePayLogo_svg__Path_16",
    "data-name": "Path 16",
    className: "GooglePayLogo_svg__cls-3",
    d: "M332.819 54.7a5.026 5.026 0 013.555 1.206 4.28 4.28 0 011.3 3.3v6.666h-1.934v-1.5h-.085a3.864 3.864 0 01-3.354 1.852 4.355 4.355 0 01-2.994-1.058 3.379 3.379 0 01-1.206-2.645 3.2 3.2 0 011.27-2.666 5.327 5.327 0 013.386-.995 5.918 5.918 0 012.973.667v-.466a2.306 2.306 0 00-.836-1.8 2.868 2.868 0 00-1.968-.741 3.087 3.087 0 00-2.688 1.439l-1.788-1.122a4.962 4.962 0 014.37-2.137m-2.62 7.851a1.6 1.6 0 00.677 1.323 2.487 2.487 0 001.577.529 3.222 3.222 0 002.286-.952 2.988 2.988 0 001.005-2.233 4.185 4.185 0 00-2.645-.751 3.472 3.472 0 00-2.063.593 1.807 1.807 0 00-.836 1.492",
    transform: "translate(-293.383 -48.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GooglePayLogo_svg__Path_17",
    "data-name": "Path 17",
    className: "GooglePayLogo_svg__cls-3",
    d: "M431.614 58l-6.772 15.575h-2.1l2.518-5.449L420.8 58h2.211l3.217 7.767h.042L429.4 58z",
    transform: "translate(-376.274 -51.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GooglePayLogo_svg__Path_18",
    "data-name": "Path 18",
    d: "M94.335 71.5a10.694 10.694 0 00-.169-1.906H85.65v3.492h4.9a4.2 4.2 0 01-1.82 2.812v2.265h2.919a8.874 8.874 0 002.686-6.663",
    transform: "translate(-76.587 -62.227)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GooglePayLogo_svg__Path_19",
    "data-name": "Path 19",
    d: "M20.294 104.9a5.493 5.493 0 01-8.173-2.873H9.11v2.336a9.065 9.065 0 008.1 4.992 8.646 8.646 0 006-2.191z",
    transform: "translate(-8.146 -91.234)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GooglePayLogo_svg__Path_20",
    "data-name": "Path 20",
    d: "M3.692 51.251a5.466 5.466 0 01.284-1.734V47.18H.964a9.077 9.077 0 000 8.141l3.011-2.336a5.466 5.466 0 01-.284-1.734",
    transform: "translate(0 -42.188)",
    fill: "#fabb05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GooglePayLogo_svg__Path_21",
    "data-name": "Path 21",
    d: "M17.211 3.587a4.926 4.926 0 013.478 1.36l2.587-2.585A8.708 8.708 0 0017.211 0a9.067 9.067 0 00-8.1 4.992l3.011 2.336a5.423 5.423 0 015.09-3.742",
    transform: "translate(-8.146)",
    fill: "#e94235"
  }))));
}
export default __webpack_public_path__ + "7289571579335e4b39b9faede86f61fa.svg";
export { SvgGooglePayLogo as ReactComponent };